// extracted by mini-css-extract-plugin
export default {"columnTitle":"L6HeLanDFv7GVy2KtCE2","placeHolderShimmer":"cUPm75Gfxd0beldse6B8"};